import { render, staticRenderFns } from "./MVMCases.vue?vue&type=template&id=42fa65e4&"
import script from "./MVMCases.vue?vue&type=script&lang=js&"
export * from "./MVMCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports